<p-toast baseZIndex="5000" key="idioma"></p-toast>

<div
  class="modal fade"
  bsModal
  #profile_modal="bs-modal"
  [config]="{ backdrop: 'static' }"
  tabindex="-1"
  role="dialog"
>
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row">
          <div
            class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-bottom foto_user text-center"
          >
            <button
              (click)="profile_modal.hide()"
              class="close pull-right"
              type="button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
            <img
              class="rounded-circle"
              src="{{ user?.foto }}"
              src-fallback="./assets/img/undraw_profile.svg"
            />
            <h5 class="margin-top text-primary">
              {{ user?.nombre_completo || "" }}
            </h5>
            <ng-container *ngIf="!anonUser">
              {{ user?.rut }}<br />
              {{ user?.correo_uv }}
            </ng-container>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-bottom">
            {{ "usuario.profile.idioma" | translate }}<br />
            <p-dropdown
              (onChange)="change_idioma($event)"
              [style]="{ width: '100%' }"
              [options]="combo_idiomas"
              [(ngModel)]="idioma_selected"
            >
              <ng-template let-item pTemplate="selectedItem">
                <div class="country-item country-item-value">
                  <img
                    src="{{ config.SISTEMA.URL.REPOSITORIO }}imagenes/idiomas/{{
                      idioma_selected.toLowerCase()
                    }}.png"
                    [class]="'flag flag-' + idioma_selected.toLowerCase()"
                  />
                  <div>{{ idioma_selected.toUpperCase() }}</div>
                </div>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <div class="country-item">
                  <img
                    src="{{ config.SISTEMA.URL.REPOSITORIO }}imagenes/idiomas/{{
                      item.label.toLowerCase()
                    }}.png"
                    [class]="'flag flag-' + item.value.toLowerCase()"
                  />
                  <div>{{ item.label }}</div>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
